import React from 'react';
import { Button } from '../common';
import { Card } from '../common/Card';
import { Heading, Text, Typography } from '../common/Typography';

/**
 * Action dashboard showing pending items for tournament hosts
 */
const ActionDashboard = ({ 
  actionItems = [], 
  onActionClick 
}) => {
  const handleActionClick = (action) => {
    if (onActionClick && action) {
      onActionClick(action);
    }
  };

  const getActionIcon = (type) => {
    switch (type) {
      case 'warning':
        return '⚠️';
      case 'success':
        return '✅';
      case 'info':
        return 'ℹ️';
      default:
        return '📌';
    }
  };

  const getCardVariant = (type) => {
    switch (type) {
      case 'warning':
        return 'warning';
      case 'success':
        return 'success';
      case 'info':
        return 'info';
      default:
        return 'default';
    }
  };

  const getActionButtonText = (item) => {
    // Return custom button text based on the action
    if (item.title.includes('Add More Teams') || item.title.includes('Add Teams')) {
      return 'Add Teams';
    }
    if (item.title.includes('Solo Players')) {
      return 'View Teams';
    }
    if (item.title.includes('Configure Groups')) {
      return 'Configure Groups';
    }
    if (item.title.includes('Unassigned Teams')) {
      return 'Assign Teams';
    }
    if (item.title.includes('Generate Matches')) {
      return 'Generate Matches';
    }
    if (item.title.includes('Pending')) {
      return 'Enter Scores';
    }
    if (item.title.includes('Ready for Knockout')) {
      return 'Setup Knockout';
    }
    
    // Default based on type
    if (item.type === 'warning') return 'Resolve';
    if (item.type === 'success') return 'Continue';
    return 'View';
  };

  return (
    <div className="space-y-6">
      {/* Action Items */}
      {actionItems.length > 0 && (
        <div>
          <Heading level={4} className="mb-3 text-base sm:text-lg">
            Action Items
          </Heading>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            {actionItems.map((item, index) => (
              <Card 
                key={index} 
                variant={getCardVariant(item.type)} 
                size="small"
                className="relative"
              >
                <div className="flex items-start gap-3">
                  <div className="text-2xl shrink-0" aria-hidden="true">
                    {getActionIcon(item.type)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <Typography variant="strong" className="text-sm mb-1 block">
                      {item.title}
                    </Typography>
                    <Text className="text-xs text-text-secondary mb-2">
                      {item.description}
                    </Text>
                    {item.action && (
                      <Button
                        variant={item.type === 'warning' ? 'warning' : item.type === 'success' ? 'success' : 'primary'}
                        size="small"
                        onClick={() => handleActionClick(item.action)}
                        className="text-xs"
                      >
                        {getActionButtonText(item)}
                      </Button>
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      )}

      {/* Empty state */}
      {actionItems.length === 0 && (
        <Card variant="muted" size="medium" className="text-center">
          <div className="text-4xl mb-3">✨</div>
          <Typography variant="strong" className="mb-1">
            All Caught Up!
          </Typography>
          <Text className="text-text-secondary text-sm">
            No pending actions. Your tournament is running smoothly.
          </Text>
        </Card>
      )}
    </div>
  );
};

export default ActionDashboard;
